export const searchParamsToJSON = (searchParams: URLSearchParams, arrayKeys?: string[]) => {
  const params: { [k: string]: string | string[] | boolean } = Object.fromEntries(searchParams.entries());

  Object.entries(params).forEach(([key, value]) => {
    if (typeof value === "string") {
      if (value.includes(",")) {
        params[key] = value.split(",");
      } else if (arrayKeys && arrayKeys.includes(key)) {
        params[key] = [value];
      }
    }
  });

  return params;
};
